import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { trustPoints } from "@/mocks/home";

const levelRows = [
  { label: "官方回应", desc: "来自公开声明或官方账号，可直接引用", tone: "bg-accent-500 text-background-50" },
  { label: "多源提及", desc: "两个以上独立来源指向同一件事", tone: "bg-secondary-500 text-foreground-950" },
  { label: "待核实线索", desc: "仅单一投稿，先当线索看，不要下结论", tone: "bg-primary-500 text-background-50" },
];

export default function TrustSection() {
  return (
    <section id="trust" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="内容说明"
            tone="primary"
            title="吃瓜之前，先说清楚信息是从哪来的"
            description="一区不生产结论，只负责把线索摆整齐。来源、时间、核实状态都会写在条目里，让每个人都能自己判断。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-2">
            {trustPoints.map((point, index) => (
              <Reveal key={point.title} delay={index * 60}>
                <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100">
                    <i className={`${point.icon} text-xl text-primary-700`} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                    {point.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={160}>
            <div className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="h-44 w-full md:h-52">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20close%20up%20of%20stacked%20layered%20paper%20cards%20in%20warm%20cream%20and%20deep%20crimson%20tones%2C%20thin%20teal%20green%20edge%20accents%2C%20soft%20studio%20light%2C%20clean%20minimal%20editorial%20still%20life%20texture%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=900&height=700&seq=hl-yiqu-trust-02&orientation=squarish"
                  alt="黑料一区内容核实与来源标注说明"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">内容分级一览</h3>
                <ul className="mt-4 flex flex-1 flex-col gap-3">
                  {levelRows.map((row) => (
                    <li key={row.label} className="flex items-start gap-3">
                      <span
                        className={`mt-0.5 shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium ${row.tone}`}
                      >
                        {row.label}
                      </span>
                      <span className="text-xs leading-relaxed text-foreground-600">{row.desc}</span>
                    </li>
                  ))}
                </ul>
                <p className="mt-4 border-t border-background-200 pt-4 text-xs leading-relaxed text-foreground-500">
                  条目状态会随官方回应实时更新，被证伪的内容会保留更正记录，不做删除处理。
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}